const useCurrentSpace = () => {
   return 'core';
}

export default useCurrentSpace;
